import { css } from 'styled-components';

import { breakpointsMapFunc } from './grid';
import { Theme } from './index';
import { BreakpointNames } from './types';

type TemplateFnArg = number;
type TemplateFn = (n: TemplateFnArg) => string;

export const mqMin = (n: TemplateFnArg) => `(min-width: ${n})`;
export const mqMinScreen = (n: TemplateFnArg) => {
  return `@media screen and ${mqMin(n)}`;
};

export const mqMaxScreen = (n: TemplateFnArg) => {
  const mw = Number(String(n).replace('px', '')) - 1;
  return `@media screen and (max-width: ${mw}px)`;
};

const mediaQuery = (label: string, tplFn: TemplateFn) => {
  return ({ theme }: { theme: Theme }) => tplFn(breakpointsMapFunc(theme)[label as BreakpointNames] as any);
};

const createMedia = (tplFn: TemplateFn) => {
  const func =
    (label: BreakpointNames) =>
    (strings: any, ...args: any[]) =>
      css`
        ${mediaQuery(label, tplFn)} {
          ${css(strings, ...args)};
        }
      ` as any;

  return {
    sm: func(BreakpointNames.sm) as any,
    md: func(BreakpointNames.md) as any,
    lg: func(BreakpointNames.lg) as any,
    xl: func(BreakpointNames.xl) as any,
    xxl: func(BreakpointNames.xxl) as any,
  };
};

export const media = {
  from: createMedia(mqMinScreen),
  to: createMedia(mqMaxScreen), // !!! Please use mobile first approach rather where possible
};
